import {TranslationCodeView} from "../translation/TranslationCodeView";
import {JobOverallAssessmentTypeDtoModel} from "../designations-and-icon/job-overall-assessment-type-dto.model";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

//region ENUMS
export enum WorkflowOverviewItemType {
  GROUP = 'GROUP',
  TITLE = 'TITLE',
  SEPARATOR = 'SEPARATOR',
  ENTRY = 'ENTRY'
}

export enum WorkflowOverviewItemState {
  NOT_FILLED = 'NOT_FILLED',
  FILLED = 'FILLED',
  FILLED_AND_CHECKED = 'FILLED_AND_CHECKED'
}
//endregion

//region MODELS
export abstract class WorkflowOverviewItem {
  abstract type: WorkflowOverviewItemType;
  id: string;
}

export class WorkflowOverviewGroup extends WorkflowOverviewItem {
  readonly type: WorkflowOverviewItemType = WorkflowOverviewItemType.GROUP;
  items: WorkflowOverviewItem[] = [];
}

export class WorkflowOverviewTitle extends WorkflowOverviewItem {
  readonly type: WorkflowOverviewItemType = WorkflowOverviewItemType.TITLE;
  numbering: string;
  name: TranslationCodeView;
  infoText: string;
  collapsedInfoText: string;
  children: WorkflowOverviewItem[] = [];
}

export class WorkflowOverviewSeparator extends WorkflowOverviewItem {
  readonly type: WorkflowOverviewItemType = WorkflowOverviewItemType.SEPARATOR;
}

export class WorkflowOverviewEntry extends WorkflowOverviewItem {
  readonly type: WorkflowOverviewItemType = WorkflowOverviewItemType.ENTRY;
  state: WorkflowOverviewItemState;
  numbering: string;
  name: TranslationCodeView;
  label: string;
  disabled: boolean;
  disabledIcon: IconProp;
  disabledLabel: string;
  counterValue: string;
  counterLabel: string;
  badgeValue: string;
  assessment: JobOverallAssessmentTypeDtoModel[];
  infoText: string;
  collapsedInfoText: string;
  children: WorkflowOverviewItem[] = [];
}
//endregion
